type NayaWordmarkProps = {
  className?: string
}

/**
 * Static brand wordmark for the owner/staff login + setup screens — the one
 * place OWNER-STAFF-DESIGN-LANGUAGE.md §3 keeps a serif touch. It's a plain
 * inline SVG using the system serif stack rather than a live Cormorant
 * Garamond import, so it never costs a web-font request and can't flash
 * unstyled on slow counter wifi. `fill="currentColor"` picks up the host
 * element's color (theme-aware); the full stop stays terracotta via the
 * accent token.
 */
export function NayaWordmark({ className }: NayaWordmarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 92 34"
      role="img"
      aria-label="Naya"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="27"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="29"
        fontWeight="600"
        letterSpacing="-0.01em"
        fill="currentColor"
      >
        Naya<tspan fill="var(--owner-accent)">.</tspan>
      </text>
    </svg>
  )
}
